import { Location } from '@angular/common';
import { Component, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UtilService } from 'src/app/services/util.service';
import { ModalSign } from '../../new-contract-large-accounts.model';
import { NewContractLargeAccountsService } from '../../new-contract-large-accounts.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-new-contract-modal-sign',
  templateUrl: './new-contract-modal-sign.component.html',
  styleUrls: ['./new-contract-modal-sign.component.scss']
})
export class NewContractModalSignComponent implements OnDestroy {
  public sended = false;
  public isLoading = false;
  private destroyed$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private dialogRef: MatDialogRef<NewContractModalSignComponent>,
    private newContractLargeAccountsService: NewContractLargeAccountsService,
    private utilService: UtilService,
    private location: Location,
    @Inject(MAT_DIALOG_DATA) public data: ModalSign,
  ) { }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  public handleClose(): void {
    this.dialogRef.close();
  }

  public handleNavigate(): void {
    this.location.back();
  }

  public digitalSign(): void {
    this.isLoading = true;
    this.newContractLargeAccountsService.digitalSign(this.data.idContract).pipe(takeUntil(this.destroyed$)).subscribe(
      response => {
        if (response.success) {
          this.sended = response.data;
          if (!this.sended) {
            this.utilService.toastErrors(response);
          }
        } else {
          this.utilService.toastErrors(response);
        }
        this.isLoading = false;
      },
      error => {
        this.utilService.toastErrors(error);
        this.isLoading = false;
      }
    );
  }
}
